import _toConsumableArray from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _objectSpread from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.includes.js";
import SvgIcon from '@/components/svg-icon.vue';
import { mapGetters } from 'vuex';
import { setSessionStorage } from '@/utils/storage';
import * as aiApi from '@/api/ai';
export default {
  components: {
    SvgIcon: SvgIcon
  },
  data: function data() {
    return {
      visible: false,
      // 控制popup
      loading: false,
      // 是否正在请求
      historyList: [],
      // 历史列表
      pagination: {
        current: 0,
        size: 50,
        total: 0
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('ai', ['aiLoading', 'topBarHeight'])), {}, {
    height: function height() {
      return "calc(100vh - ".concat(this.topBarHeight, "px)");
    }
  }),
  methods: {
    renderQuestion: function renderQuestion(question) {
      if (question.includes('###JUHUI###FAGUIJIEDU###')) {
        return '<div class="analysis-tag">法规解读</div>' + (question.split('###TITEL###')[1] || '未知标题');
      } else {
        return question;
      }
    },
    /**
     * 关闭
     */
    handleClose: function handleClose() {
      this.visible = false;
    },
    /**
     * 滚动加载
     */
    handleScroll: function handleScroll() {
      var container = this.$refs.scrollContainer;
      var scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight;

      // 距离底部小于1px时触发加载
      if (scrollBottom < 1 && !this.loading) {
        this.loadMore();
      }
    },
    /**
     * 点击查看
     * @param item
     */
    handleClick: function handleClick(item) {
      var _this = this;
      if (this.aiLoading) {
        return _Toast.fail('请先停止回答!');
      }
      setTimeout(function () {
        setSessionStorage('windowId', item.windowId);
        setSessionStorage('conversationId', item.conversationId);
        _this.query(true);
        _this.$eventBus.$emit('get-conversation-record', item.windowId);
      }, 300);
      this.visible = false;
    },
    // 返回主页
    viewHistory: function viewHistory() {
      if (this.aiLoading) {
        return _Toast.fail('请先停止回答!');
      }
      this.query(true);
      this.visible = true;
    },
    /**
     * 查询
     */
    query: function query() {
      var _this2 = this;
      var cover = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var params = {};
      if (cover) {
        params.current = 1;
        params.size = this.pagination.size;
      } else {
        params.current = this.pagination.current + 1;
        params.size = this.pagination.size;
      }
      aiApi.conversationHistory(params).then(function (_ref) {
        var data = _ref.data;
        if (!cover) {
          var _this2$historyList;
          _this2.pagination.current += 1;
          _this2.pagination.total = data.total;
          (_this2$historyList = _this2.historyList).push.apply(_this2$historyList, _toConsumableArray(data.records));
        } else {
          _this2.pagination.current = 1;
          _this2.pagination.total = data.total;
          _this2.historyList = data.records;
        }
      });
    },
    /**
     * 滚动加载
     * @param e
     */
    loadMore: function loadMore() {
      // 计算一共多少页
      var totalPage = Math.ceil(this.pagination.total / this.pagination.size);

      // 判断是否为最后一页
      if (this.pagination.current < totalPage) {
        this.pagination.current += 1; // 下一页
        this.query();
      }
    }
  }
};